import { useState } from 'react'

import styled from 'styled-components'

import { Insta360StitchEnqueueTool } from './tools/Insta360StitchEnqueueTool'
import { MLEndpointTool } from './tools/MLEndpointTool'
import { XRayGeneratorTool } from './tools/XRayGeneratorTool'

const Container = styled.div`
  width: min(960px, calc(100vw - 360px));
`

const Tabs = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  border-bottom: 1px solid #e6e8ec;
  padding-bottom: 10px;
`

const TabButton = styled.button<{ $active: boolean }>`
  border: 1px solid ${props => (props.$active ? '#0a4f95' : '#ccd2db')};
  color: ${props => (props.$active ? '#0a4f95' : '#465265')};
  background: ${props => (props.$active ? '#edf4ff' : '#fff')};
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`

export const InspectionTools = () => {
  const [activeTab, setActiveTab] = useState<'ml' | 'xray' | 'insta360_stitch'>(
    'ml',
  )

  return (
    <Container>
      <Tabs>
        <TabButton
          $active={activeTab === 'ml'}
          onClick={() => setActiveTab('ml')}
        >
          ML Endpoint Test
        </TabButton>
        <TabButton
          $active={activeTab === 'xray'}
          onClick={() => setActiveTab('xray')}
        >
          XRay Generator
        </TabButton>
        <TabButton
          $active={activeTab === 'insta360_stitch'}
          onClick={() => setActiveTab('insta360_stitch')}
        >
          Insta360 Stitching
        </TabButton>
      </Tabs>

      {activeTab === 'ml' ? <MLEndpointTool /> : null}
      {activeTab === 'xray' ? <XRayGeneratorTool /> : null}
      {activeTab === 'insta360_stitch' ? <Insta360StitchEnqueueTool /> : null}
    </Container>
  )
}
